<template>
  <div>
    <b-input-group v-if="in_edition" class="flex-w-stretch">
      <b-input-group-prepend>
        <b-btn
          :variant="metavariables_button_variant"
          @click="contains_metavariables = !contains_metavariables"
        >
          <span class="fas fa-code" />
        </b-btn>
      </b-input-group-prepend>
      <b-form-input v-model="name" :placeholder="$t('enter_column_name')" />
    </b-input-group>
    <div v-else>
      <span class="fas fa-code mx-2" :class="code_symbol_visibility" />
      <span v-c-tooltip="name">
        {{ name }}
      </span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { GenericColumnName } from '@/components/object_model.js'

export default {
  name: 'ManualColumnName',

  props: {
    value: undefined,
    in_edition: { default: true },
  },
  data() {
    return {
      name: '',
      contains_metavariables: undefined,
    }
  },

  computed: {
    metavariables_button_variant() {
      let res
      if (this.contains_metavariables) {
        res = 'secondary'
      } else {
        res = 'outline-secondary'
      }
      return res
    },

    code_symbol_visibility() {
      let res
      if (!this.in_edition && this.contains_metavariables) {
        res = 'visible'
      } else {
        res = 'invisible'
      }
      return res
    },
    local_value() {
      let res = new GenericColumnName(this.name, this.contains_metavariables)
      return res
    },
  },

  watch: {
    value: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          this.name = nv.name
          this.contains_metavariables = nv.contains_metavariables
        }
      },
    },
    local_value: {
      immediate: true,
      deep: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, this.value)) {
          this.$emit('input', _.cloneDeep(nv))
        }
      },
    },
  },
}
</script>
